import { render, staticRenderFns } from "./designImage.vue?vue&type=template&id=322f56c0&scoped=true"
import script from "./designImage.vue?vue&type=script&lang=js"
export * from "./designImage.vue?vue&type=script&lang=js"
import style0 from "./designImage.vue?vue&type=style&index=0&id=322f56c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f56c0",
  null
  
)

export default component.exports